/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerdone1Inputs */

const en_flyerdone1 = /** @type {(inputs: Flyerdone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer created and saved to your media library.`)
};

const de_flyerdone1 = /** @type {(inputs: Flyerdone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer erstellt und in deiner Mediathek gespeichert.`)
};

/**
* | output |
* | --- |
* | "Flyer created and saved to your media library." |
*
* @param {Flyerdone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerdone1 = /** @type {((inputs?: Flyerdone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerdone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerdone1(inputs)
	return de_flyerdone1(inputs)
});
export { flyerdone1 as "flyerDone" }